export default __webpack_public_path__ + "static/media/loading-icon.5e4ea2fa.svg";